<template>
	<div class="-page" id="app">
		<router-view></router-view>
	</div>
</template>
